import { useEffect, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
  useSearchParams
} from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { getPatientDocuments } from 'api/Documents';

import { ia } from 'lib/helpers/utility';

import { userState } from '../../../state';
import { showAlert } from '../../Alert/Alert';
import { PREFIX_KIND, REVERSE_PREFIX_KIND, formatViewDocument } from '../lib/helpers';

export default function useSingleDocument({ categories, viewDocument, setViewDocument }) {
  const currentUser = useRecoilValue(userState);

  const { myPortalPractice } = useParams();
  const [searchParams] = useSearchParams();
  const [documentIdParam, setDocumentIdParam] = useState(searchParams.get('document_id'));

  const { patient } = useOutletContext() || {};

  const patientId = patient?.id || currentUser?.id;

  const navigate = useNavigate();

  const { pathname } = useLocation();

  useEffect(() => {
    if (viewDocument?.id) {
      navigate(
        `?document_id=${PREFIX_KIND[viewDocument?.kind || 'patient_documents']}-${viewDocument?.id}`
      );
    } else if (!documentIdParam) {
      navigate(pathname);
    }
  }, [viewDocument, documentIdParam]);

  useEffect(() => {
    const getParamDocument = async () => {
      if (documentIdParam) {
        const [kind, id] = documentIdParam.split('-');
        const data = await getPatientDocuments(navigate, {
          id,
          kind: REVERSE_PREFIX_KIND[kind],
          patientId,
          myPortalPractice
        });

        if (data?.document) {
          setViewDocument(formatViewDocument(data?.document, categories));

          setDocumentIdParam(null);
        } else {
          setViewDocument(null);
          showAlert({
            message: 'Document not found',
            color: 'danger'
          });
        }
      }
    };

    if (ia(categories)) {
      getParamDocument();
    }
  }, [categories]);

  return documentIdParam;
}
